import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { injectIntl, intlShape } from 'react-intl';
import Select from 'react-select';
import RegexpInput from 'shared/components/RegexpInput/RegexpInput';
import SelectTranslated from '../../SelectTranslated/SelectTranslated';
import s from './SpecialPanel.css';

export const TYPES = {
  avtobus: 'avtobus',
  pritsepy: 'pritsepy',
  gruzovye: 'gruzovye',
  spetstehnika: 'spetstehnika',
  vodnyiTransport: 'vodnyi-transport',
};

class SpecialPanel extends React.Component {
  static propTypes = {
    selectedActions: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    type: PropTypes.string,
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    type: null,
  };

  render() {
    const { formVocabulary, formState, selectedActions, type, intl } = this.props;

    const { unloadings, ecotypes, engines, drives, gearboxes } = formVocabulary;
    const selectedSetActions = selectedActions.set;

    if (!type) {
      return null;
    }

    return (
      <div className={s.root}>
        {(() => {
          switch (type) {
            case TYPES.avtobus: {
              return (
                <div className={s.mainform}>
                  <div className={s.filterItem}>
                    <Select
                      placeholder={intl.formatMessage({ id: 'Колесная формула' })}
                      instanceId="drive-ff"
                      name="drive"
                      labelKey="title"
                      valueKey="id"
                      options={drives}
                      disabled={!(drives && drives.length > 0)}
                      onChange={selectedSetActions.drive}
                      value={formState.drive}
                    />
                  </div>

                  <div className={s.filterItem}>
                    <SelectTranslated
                      placeholder={intl.formatMessage({ id: 'Коробка' })}
                      instanceId="gearbox-ff"
                      name="gearboxes"
                      labelKey="title"
                      valueKey="id"
                      options={gearboxes}
                      disabled={!(gearboxes && gearboxes.length > 0)}
                      onChange={selectedSetActions.gearbox}
                      value={formState.gearbox}
                    />
                  </div>

                  <div className={s.filterItem}>
                    <div className={s.flexContainer}>
                      <div className={s.left}>
                        <SelectTranslated
                          placeholder={intl.formatMessage({ id: 'двигатель' })}
                          instanceId="engine-ff"
                          name="engine"
                          labelKey="title"
                          valueKey="id"
                          options={engines}
                          disabled={!(engines && engines.length > 0)}
                          onChange={selectedSetActions.engine}
                          value={formState.engine}
                        />
                      </div>
                      <div className={s.right}>
                        <SelectTranslated
                          placeholder={intl.formatMessage({ id: 'Эконормы' })}
                          instanceId="type-ff"
                          name="drives"
                          labelKey="title"
                          valueKey="id"
                          options={ecotypes}
                          disabled={!(ecotypes && ecotypes.length > 0)}
                          onChange={selectedSetActions.ecotype}
                          value={formState.ecotype}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
            }
            case TYPES.gruzovye: {
              return (
                <div className={s.mainform}>
                  <div className={s.filterItem}>
                    <Select
                      placeholder={intl.formatMessage({ id: 'Колесная формула' })}
                      instanceId="drive-ff"
                      name="drive"
                      labelKey="title"
                      valueKey="id"
                      options={drives}
                      disabled={!(drives && drives.length > 0)}
                      onChange={selectedSetActions.drive}
                      value={formState.drive}
                    />
                  </div>

                  <div className={s.filterItem}>
                    <SelectTranslated
                      placeholder={intl.formatMessage({ id: 'Коробка' })}
                      instanceId="gearbox-ff"
                      name="gearboxes"
                      labelKey="title"
                      valueKey="id"
                      options={gearboxes}
                      disabled={!(gearboxes && gearboxes.length > 0)}
                      onChange={selectedSetActions.gearbox}
                      value={formState.gearbox}
                    />
                  </div>

                  <div className={s.filterItem}>
                    <div className={s.flexContainer}>
                      <div className={s.left}>
                        <SelectTranslated
                          placeholder={intl.formatMessage({ id: 'двигатель' })}
                          instanceId="engine-ff"
                          name="engine"
                          labelKey="title"
                          valueKey="id"
                          options={engines}
                          disabled={!(engines && engines.length > 0)}
                          onChange={selectedSetActions.engine}
                          value={formState.engine}
                        />
                      </div>
                      <div className={s.right}>
                        <SelectTranslated
                          placeholder={intl.formatMessage({ id: 'Эконормы' })}
                          instanceId="type-ff"
                          name="drives"
                          labelKey="title"
                          valueKey="id"
                          options={ecotypes}
                          disabled={!(ecotypes && ecotypes.length > 0)}
                          onChange={selectedSetActions.ecotype}
                          value={formState.ecotype}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
            }
            case TYPES.pritsepy: {
              return (
                <div className={s.mainform}>
                  <div className={s.filterItem}>
                    <Select
                      placeholder={intl.formatMessage({ id: 'Колесная формула' })}
                      instanceId="drive-ff"
                      name="drive"
                      labelKey="title"
                      valueKey="id"
                      options={drives}
                      disabled={!(drives && drives.length > 0)}
                      onChange={selectedSetActions.drive}
                      value={formState.drive}
                    />
                  </div>

                  <div className={s.filterItem}>
                    <SelectTranslated
                      placeholder={intl.formatMessage({ id: 'Выгрузка' })}
                      instanceId="unloading-ff"
                      name="unloadings"
                      labelKey="title"
                      valueKey="id"
                      options={unloadings}
                      disabled={!(unloadings && unloadings.length > 0)}
                      onChange={selectedSetActions.unloading}
                      value={formState.unloading}
                    />
                  </div>

                  <div className={s.filterItem}>
                    <RegexpInput
                      className={cx(s.input, s.from)}
                      type="text"
                      placeholder={intl.formatMessage({ id: 'Гр-сть, от' })}
                      value={formState.tonnageFrom || ''}
                      onChange={selectedSetActions.tonnageFrom}
                      pattern={'^[0-9]+$'}
                    />
                    <RegexpInput
                      className={cx(s.input, s.to)}
                      type="text"
                      placeholder={intl.formatMessage({ id: 'до' })}
                      value={formState.tonnageTo || ''}
                      onChange={selectedSetActions.tonnageTo}
                      pattern={'^[0-9]+$'}
                    />
                  </div>
                </div>
              );
            }
            case TYPES.spetstehnika: {
              return (
                <div className={s.mainform}>
                  <div className={s.filterItem}>
                    <RegexpInput
                      className={cx(s.input, s.from)}
                      type="text"
                      placeholder={intl.formatMessage({ id: 'Гр-сть, от' })}
                      value={formState.tonnageFrom || ''}
                      onChange={selectedSetActions.tonnageFrom}
                      pattern={'^[0-9]+$'}
                    />
                    <RegexpInput
                      className={cx(s.input, s.to)}
                      type="text"
                      placeholder={intl.formatMessage({ id: 'до' })}
                      value={formState.tonnageTo || ''}
                      onChange={selectedSetActions.tonnageTo}
                      pattern={'^[0-9]+$'}
                    />
                  </div>

                  <div className={s.filterItem}>
                    <div className={s.flexContainer}>
                      <div className={s.left}>
                        <SelectTranslated
                          placeholder={intl.formatMessage({ id: 'Коробка' })}
                          instanceId="gearbox-ff"
                          name="gearboxes"
                          labelKey="title"
                          valueKey="id"
                          options={gearboxes}
                          disabled={!(gearboxes && gearboxes.length > 0)}
                          onChange={selectedSetActions.gearbox}
                          value={formState.gearbox}
                        />
                      </div>
                      <div className={s.right}>
                        <SelectTranslated
                          placeholder={intl.formatMessage({ id: 'Выгрузка' })}
                          instanceId="unloading-ff"
                          name="unloadings"
                          labelKey="title"
                          valueKey="id"
                          options={unloadings}
                          disabled={!(unloadings && unloadings.length > 0)}
                          onChange={selectedSetActions.unloading}
                          value={formState.unloading}
                        />
                      </div>
                    </div>
                  </div>

                  <div className={s.filterItem}>
                    <div className={s.flexContainer}>
                      <div className={s.left}>
                        <SelectTranslated
                          placeholder={intl.formatMessage({ id: 'двигатель' })}
                          instanceId="engine-ff"
                          name="engine"
                          labelKey="title"
                          valueKey="id"
                          options={engines}
                          disabled={!(engines && engines.length > 0)}
                          onChange={selectedSetActions.engine}
                          value={formState.engine}
                        />
                      </div>
                      <div className={s.right}>
                        <SelectTranslated
                          placeholder={intl.formatMessage({ id: 'Эконормы' })}
                          instanceId="type-ff"
                          name="drives"
                          labelKey="title"
                          valueKey="id"
                          options={ecotypes}
                          disabled={!(ecotypes && ecotypes.length > 0)}
                          onChange={selectedSetActions.ecotype}
                          value={formState.ecotype}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
            }
            case TYPES.vodnyiTransport: {
              return (
                <div className={s.filterItem}>
                  <SelectTranslated
                    placeholder={intl.formatMessage({ id: 'двигатель' })}
                    instanceId="engine-ff"
                    name="engine"
                    labelKey="title"
                    valueKey="id"
                    options={engines}
                    disabled={!(engines && engines.length > 0)}
                    onChange={selectedSetActions.engine}
                    value={formState.engine}
                  />
                </div>
              );
            }
            default: {
              return null;
            }
          }
        })()}
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(SpecialPanel));



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanelV2/CommercialPanel/SpecialPanel/SpecialPanel.js